import LocaleLink from '@/components/LocaleLink';
import { useLocale } from '@/hooks/useLocale';
import { HOME_FEATURES_EN } from '@/copy/home-features-en';
import { HOME_FEATURES_AR } from '@/copy/home-features-ar';
import './FeaturesSection.css';

/* Homepage "What Prinotes does" section — sits below the Hero. Its primary
 * job is disclosure: a plain-language description of the app and how it uses
 * each connected Google scope, so the OAuth verification reviewer can read
 * the purpose straight off the home page. Kept consistent with the Privacy
 * Policy integrations section (see home-features-en.ts). */
export default function FeaturesSection() {
  const { locale, dir } = useLocale();
  const doc = locale === 'ar' ? HOME_FEATURES_AR : HOME_FEATURES_EN;

  return (
    <section className="home-features" dir={dir} aria-labelledby="home-features-h">
      <div className="mkt-container home-features__inner">
        <p className="mkt-eyebrow" style={{ margin: 0 }}>
          {doc.eyebrow}
        </p>
        <h2 id="home-features-h" className="home-features__title">
          {doc.heading.includes('PRINOTES') ? (
            <>
              {doc.heading.split('PRINOTES')[0]}
              <span className="home-features__pri">PRI</span>NOTES
              {doc.heading.split('PRINOTES')[1]}
            </>
          ) : (
            doc.heading
          )}
        </h2>
        <p className="home-features__lead">{doc.lead}</p>

        <ul className="home-features__grid">
          {doc.features.map((f) => (
            <li key={f.title} className="home-features__card">
              <h3 className="home-features__card-title">{f.title}</h3>
              <p className="home-features__card-body">{f.body}</p>
            </li>
          ))}
        </ul>

        <p className="home-features__privacy">
          {doc.privacyBefore}
          <LocaleLink to="/privacy" className="home-features__link">
            {doc.privacyLinkLabel}
          </LocaleLink>
          {doc.privacyAfter}
        </p>
        <p className="home-features__limited-use">{doc.limitedUse}</p>
      </div>
    </section>
  );
}
